import { useEffect } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { useNavigate } from 'react-router-dom';

interface CommandPaletteProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Cmd-K command palette per spec §3 (Linear-style).
 * Stub — full fuzzy search of routes + KPIs + members (PHI-tier-aware) goes here.
 */
export function CommandPalette({ open, onClose }: CommandPaletteProps) {
  const navigate = useNavigate();

  useEffect(() => {
    function onKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        // Toggle handled via state hook; this is just keybind plumbing
      }
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[2000] bg-black/50" />
        <Dialog.Content
          className="fixed top-[20%] left-1/2 -translate-x-1/2 z-[2001] w-[600px] max-w-[90vw] bg-cdx-surface-0 border border-cdx-border-strong rounded-cdx shadow-2xl"
          aria-label="command palette"
        >
          <Dialog.Title className="sr-only">Command palette</Dialog.Title>
          <input
            type="text"
            autoFocus
            placeholder="Search routes, KPIs, members…"
            className="w-full px-4 py-3 bg-transparent border-b border-cdx-border-subtle outline-none text-sm"
            onKeyDown={(e) => {
              // Stub: jump to a route on Enter
              if (e.key === 'Enter') {
                navigate('/');
                onClose();
              }
            }}
          />
          <div className="px-4 py-3 text-xs text-cdx-fg-muted">
            <p>TODO: fuzzy search of routes, KPI catalog, member lookup (tier-aware), recent searches.</p>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
